module.exports = __webpack_public_path__ + "static/img/szafa_22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/_kopia/szafa_22.jpg
// module id = QM70
// module chunks = 0